module.exports = __webpack_public_path__ + "static/media/contact.9171b1f4.svg";